import {
    ApiFilled,
    ApiOutlined,
    AppstoreOutlined,
    BarChartOutlined,
    BgColorsOutlined,
    BugOutlined,
    CreditCardOutlined,
    DollarCircleOutlined,
    DollarOutlined,
    EyeOutlined,
    FileOutlined,
    FileSearchOutlined,
    FilterOutlined,
    FunnelPlotOutlined,
    LayoutOutlined,
    PicRightOutlined,
    PictureOutlined,
    RetweetOutlined,
    RocketOutlined,
    SaveOutlined,
    SettingFilled,
    SettingOutlined,
    ShopFilled,
    ShopOutlined,
    ShoppingFilled,
    TeamOutlined,
    UserOutlined
} from '@ant-design/icons';
import {AgencyBean} from 'common/api/api.ts';
import {MenuItem} from 'common/components/sidebar/Sidebar.tsx';
import FeatureAccessEnum = AgencyBean.FeatureAccessEnum

export const menuTabs: MenuItem[] = [
    {
        label: 'Dashboard',
        key: 'dashboard',
        url: 'dashboard',
        icon: <AppstoreOutlined/>,
    },
    {
        label: 'Report Builder',
        key: 'report-builder',
        url: 'report-builder',
        icon: <BarChartOutlined/>,
    },
    {
        label: 'Saved Reports',
        key: 'report',
        url: 'report',
        icon: <SaveOutlined/>,
    },
    {
        label: 'Supply',
        key: 'supply',
        url: '',
        icon: <ShopFilled/>,
        access: [FeatureAccessEnum.SSP, FeatureAccessEnum.Publisher],
        children: [
            {
                label: 'SSP',
                key: 'ssp',
                url: 'ssp',
                icon: <ApiOutlined/>,
                access: [FeatureAccessEnum.SSP],
            },
            {
                label: 'Publishers',
                key: 'publishers',
                url: 'publishers',
                icon: <TeamOutlined/>,
                access: [FeatureAccessEnum.Publisher],
            },
            {
                label: 'Sites',
                key: 'sites',
                url: 'sites',
                icon: <PicRightOutlined/>,
                access: [FeatureAccessEnum.Publisher],
            },
            {
                label: 'Ad Units',
                key: 'ad-units',
                url: 'ad-units',
                icon: <LayoutOutlined/>,
                access: [FeatureAccessEnum.Publisher],
            },
            {
                label: 'Deals',
                key: 'deals',
                url: 'deals',
                icon: <ShopOutlined/>,
                access: [FeatureAccessEnum.Publisher],
            },
        ],
    },
    {
        label: 'Demand',
        key: 'demand',
        url: '',
        icon: <ShoppingFilled/>,
        access: [FeatureAccessEnum.Advertiser, FeatureAccessEnum.DSP],
        children: [
            {
                label: 'Advertisers',
                key: 'adv',
                url: 'adv',
                icon: <UserOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Campaigns',
                key: 'campaign',
                url: 'campaign',
                icon: <RocketOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Ad Groups',
                key: 'ad-group',
                url: 'ad-group',
                icon: <FileOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Creatives',
                key: 'creative',
                url: 'creative',
                icon: <PictureOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Trackers',
                key: 'tracker',
                url: 'tracker',
                access: [FeatureAccessEnum.Advertiser],
                icon: <EyeOutlined/>,
            },
            // {
            //     label: 'Tracker Statistics',
            //     key: 'tracker-event-stats',
            //     url: 'tracker-event-stats',
            //     access: [FeatureAccessEnum.Advertiser],
            //     icon: <DatabaseOutlined/>,
            // },
            {
                label: 'Tracker Reports',
                key: 'tracker-event-report',
                url: 'tracker-event-report',
                access: [FeatureAccessEnum.Advertiser],
                icon: <SaveOutlined/>,
            },
            {
                label: 'Retargeting Lists',
                key: 'retargeting-list',
                url: 'retargeting-list',
                icon: <RetweetOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            // {
            //     label: 'Contextual',
            //     key: 'contextual-targeting',
            //     url: 'contextual-targeting',
            //     icon: <AimOutlined/>,
            //     access: [FeatureAccessEnum.Advertiser],
            // },
            {
                label: 'Filter Lists',
                key: 'filter-list',
                url: 'filter-list',
                icon: <FilterOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Global Filters',
                key: 'filter-list-global',
                url: 'filter-list-global',
                icon: <FunnelPlotOutlined/>,
            },
            {
                label: 'DSP',
                key: 'dsp',
                url: 'dsp',
                icon: <ApiOutlined/>,
                access: [FeatureAccessEnum.DSP],
            },
        ],
    },
    {
        label: 'Admin',
        key: 'admin',
        url: '',
        icon: <SettingFilled/>,
        children: [
            {
                label: 'Accounts',
                key: 'account',
                url: 'account',
                icon: <SettingOutlined/>,
            },
            {
                label: 'Logs',
                key: 'logs',
                url: 'logs',
                icon: <FileSearchOutlined/>,
            },
            {
                label: 'Test Request',
                key: 'request',
                url: 'request',
                icon: <ApiFilled/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'AdGroup Nbrs',
                key: 'ad-group-nbr-debug',
                url: 'ad-group-nbr-debug',
                icon: <BugOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Dsp Nbrs',
                key: 'dsp-nbr-debug',
                url: 'dsp-nbr-debug',
                icon: <BugOutlined/>,
                access: [FeatureAccessEnum.DSP],
            },
            {
                label: 'Agency Billing',
                key: 'agency-transactions',
                url: 'agency-transactions',
                icon: <DollarOutlined/>,
            },
            {
                label: 'Advertiser Billing',
                key: 'transactions',
                url: 'transactions',
                icon: <DollarCircleOutlined/>,
                access: [FeatureAccessEnum.Advertiser],
            },
            {
                label: 'Branding',
                key: 'branding',
                url: 'branding',
                icon: <BgColorsOutlined/>,
            },
            {
                label: 'Stripe',
                key: 'stripe-connect',
                url: 'stripe-connect',
                icon: <CreditCardOutlined/>,
            },
        ],
    },
]
